import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular';
import { AppSettings } from 'src/app/app.settings';
import { AppEnum } from 'src/app/appenum';
import { EncryptionService } from 'src/app/services/encryption.service';

@Component({
    selector: 'app-custom-tableval',
    templateUrl: './custom-tableval.component.html',
    styleUrls: ['./custom-tableval.component.scss'],
    standalone: false
})
export class CustomTablevalComponent implements OnInit {
  pdfSrc: string;
  value:any;
  label:any;
  previousValue:any;
  public _customTableForm: UntypedFormGroup = new UntypedFormGroup({});
  constructor(public modalCtrl: ModalController,private navParams: NavParams,private _formBuilder: UntypedFormBuilder,
    public _appSetting:AppSettings, public encryptionService : EncryptionService, public _appenum : AppEnum) { }

  ngOnInit() {
    this.value = this.navParams.data.value;
    this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.tableval, JSON.stringify(this.value))
    this.previousValue = this.value;
    this._customTableForm = this._formBuilder.group({});
  }

  closeModal() {
    this.modalCtrl.dismiss({
      data:JSON.parse(this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.tableval))),
      dismissed: true
    });
  }

  getValue(){
    this.modalCtrl.dismiss({
      data:this.value,
      dismissed:'save'
    });
  }
  setTableCtlVal(e, obj) {
    obj[e.name] = e.value;
  }
}
